<script setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
const store = useStore();
let poster = ref("");
onMounted(() => {
  let data = store.state.partnerConfig?.basic;
  if (data && data.share_content) {
    poster.value = JSON.parse(data.share_content).response.data.url;
  }
});
</script>
<template>
  <div class="main">
    <img v-if="poster" :src="poster" alt="" />
    <div v-else>暂无上传分享海报图</div>
  </div>
</template>

<style lang="scss" scoped>
.main {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
